export default {
  name: "dashboard-market-banner",
  components: {},
  props: [],
  data() {
    return {
      dashboardMarketLoader: true,
      marketUrl: process.env.VUE_APP_MARKET_BASE_URL
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this.dashboardMarketLoader = false;
    }, 1000);
  },
  methods: {}
};
